import { render, staticRenderFns } from "./product-supply-system.vue?vue&type=template&id=0ae50ec0&scoped=true&"
import script from "./product-supply-system.vue?vue&type=script&lang=js&"
export * from "./product-supply-system.vue?vue&type=script&lang=js&"
import style0 from "./product-supply-system.vue?vue&type=style&index=0&id=0ae50ec0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae50ec0",
  null
  
)

export default component.exports